import React, { useMemo } from 'react'
import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import VenuesSelectionCard from '../../../components/UserDashboard/VenuesSelectionCard/VenuesSelectionCard'

const images = [
    { src: '/images/colorpalette/colorpallette_black_silver_dark_resized.png', title: 'Black Silver Dark' },
    { src: '/images/colorpalette/colorpallette_blue_purple_muted_hydrangea_resized.png', title: 'Blue Purple Muted Hydrangea' },
	{ src: '/images/colorpalette/colorpallette_blue_purple_tropical_resized.png', title: 'Blue Purple Tropical' },
	{ src: '/images/colorpalette/colorpallette_blush_pink_coral_resized.png', title: 'Blush Pink Coral' },
	{ src: '/images/colorpalette/colorpallette_bold_fall_vibrant_resized.png', title: 'Bold Fall Vibrant' },
	{ src: '/images/colorpalette/colorpallette_classic_cream_green_butter_resized.png', title: 'Classic Cream Green Butter' },
	{ src: '/images/colorpalette/colorpallette_classic_sage_dustyrose_resized.png', title: 'Classic Sage Dustyrose' },
	{ src: '/images/colorpalette/colorpallette_eclectic_wildflower_resized.png', title: 'Eclectic Wildflower' },
	{ src: '/images/colorpalette/colorpallette_green_yellow_pink_succulent_resized.png', title: 'Green Yellow Pink Succulent' },
	{ src: '/images/colorpalette/colorpallette_pink_peonies_resized.png', title: 'Pink Peonies' },
	{ src: '/images/colorpalette/colorpallette_pink_yellow_poppies_resized.png', title: 'Pink Yellow Poppies' },
	{ src: '/images/colorpalette/colorpallette_purple_resized.png', title: 'Purple' },
	{ src: '/images/colorpalette/colorpallette_redRose_resized.png', title: 'Redrose' },
	{ src: '/images/colorpalette/colorpallette_rust_resized.png', title: 'Rust' },
	{ src: '/images/colorpalette/colorpallette_spring_pink_green_butter_resized.png', title: 'Spring Pink Green Butter' },
	{ src: '/images/colorpalette/colorpallette_sunfloweryellow_resized.png', title: 'Sunfloweryellow' },
	{ src: '/images/colorpalette/colorpallette_turquoise_silver_teal_tiffanyblue_resized.png', title: 'Turquoise Silver Teal Tiffanyblue' },
	{ src: '/images/colorpalette/colorpallette_warm_neutrals_resized.png', title: 'Warm Neutrals' },
	{ src: '/images/colorpalette/colorpallette_winter_sage_resized.png', title: 'Winter Sage' },
]

function ColorScheme({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
}) {
	const imageByTitle = useMemo(
    () => Object.fromEntries(images.map(i => [i.title, i.src])),
    []
  )

	const toggleSelect = (title) => {
    setWeddingData((prev) => {
      const isSelected = prev.colorScheme.includes(title)
      const nextColorScheme = isSelected
        ? prev.colorScheme.filter((t) => t !== title)
        : [...prev.colorScheme, title]

      const src = imageByTitle[title]
      const currentImgs = prev.selectedImages || []

      const nextSelectedImages = src
        ? (isSelected
            ? currentImgs.filter((p) => p !== src)          
            : [...currentImgs, src])                       
        : currentImgs

      return {
        ...weddingData,                 
        colorScheme: nextColorScheme,
        selectedImages: nextSelectedImages,
      }
    })
  }

	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
		>
			<div className={`${styles.welcomeModal}`}>
				<div className={styles.welcomeModalBody}>
					<h2>Do you have a color scheme you vibe with?</h2>
					<p>Select photos that match your color scheme</p>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.VenuesSelectionImages}>
							{images.map((item, index) => (
								<VenuesSelectionCard
									key={index}
									image={item.src}
									title={item.title}
									selected={weddingData.colorScheme.includes(
										item.title
									)}
									onClick={() => toggleSelect(item.title)}
								/>
							))}
						</div>
					</div>
				</div>
				<div
					className={`${styles.buttonContainer} ${styles.buttonContainerCenter}`}
				>
					<Stepper activeStep={1.8} />
					<ButtonCustom size="lg" data-cy="wizard-next" onClick={() => handleNext()}>
						Next
					</ButtonCustom>
				</div>
			</div>
		</NewWedingModal>
	)
}

export default ColorScheme
